import { render, staticRenderFns } from "./SubMenuForm.vue?vue&type=template&id=020d1de0&scoped=true&"
import script from "./SubMenuForm.vue?vue&type=script&lang=js&"
export * from "./SubMenuForm.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuForm.vue?vue&type=style&index=0&id=020d1de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d1de0",
  null
  
)

export default component.exports